import { type HTMLAttributes } from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import atomOneDark from 'react-syntax-highlighter/dist/esm/styles/hljs/atom-one-dark';

/**
 * Renders fenced code blocks with syntax highlighting in MDX.
 * Inline code (no language class) is rendered as a plain <code> element.
 * @see https://mdxjs.com/guides/syntax-highlighting/
 */
export default function CodeBlock({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLElement>) {
  const match = /language-(\w+)/.exec(className ?? '');

  if (match) {
    return (
      <SyntaxHighlighter
        language={match[1]}
        PreTag="div"
        style={atomOneDark}
        customStyle={{
          margin: '0 0 2rem 0',
          padding: '1.5rem',
          borderRadius: '8px',
          fontSize: '0.875rem',
          lineHeight: 1.5,
        }}
        codeTagProps={{ style: { fontFamily: 'inherit' } }}
        showLineNumbers={false}
      >
        {String(children).trimEnd()}
      </SyntaxHighlighter>
    );
  }

  return (
    <code className={className} {...rest}>
      {children}
    </code>
  );
}
